export const SUCCESS = 'success';
export const DANGER = 'danger';
export const PRIMARY = 'primary';
export const LINK = 'link';
export const DANGER_COLOR = '#e63934';
export const PRIMARY_COLOR = '#1399d6';
